import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { translate } from '@jsverse/transloco';

import { environment } from 'environments/environment';

@Component({
  selector: 'app-widget-notes-editor',
  templateUrl: './widget-notes-editor.component.html',
  styleUrls: ['./widget-notes-editor.component.scss'],
  standalone: false,
})
export class WidgetNotesEditorComponent implements OnInit {
  @Input() content: string;
  @Input() condensed = false;
  @Input() mode: 'html' | 'markdown' = 'html';
  @Input() widgetHeight: number;

  @Output() contentChange = new EventEmitter<string>();
  @Output() editFinished = new EventEmitter<boolean>();

  private static readonly TOOLBAR_BUTTONS = {
    moreText: {
      buttons: [
        'bold',
        'italic',
        'fontFamily',
        'fontSize',
        'underline',
        'strikeThrough',
        'subscript',
        'superscript',
        'textColor',
        'backgroundColor',
      ],
      align: 'left',
      buttonsVisible: 4,
    },
    moreParagraph: {
      buttons: [
        'alignLeft',
        'alignCenter',
        'alignRight',
        'alignJustify',
        'formatOL',
        'formatUL',
        'paragraphFormat',
        'paragraphStyle',
        'lineHeight',
        'outdent',
        'indent',
        'quote',
      ],
      align: 'left',
      buttonsVisible: 2,
    },
    moreRich: {
      buttons: ['insertImage', 'insertTable', 'insertLink', 'specialCharacters', 'insertHR'],
      align: 'left',
      buttonsVisible: 2,
    },
    moreMisc: {
      buttons: ['html'],
      align: 'right',
      buttonsVisible: 1,
    },
  };

  private static getEditorLayoutOptions(condensed: boolean, widgetHeight: number) {
    const toolbarButtons = condensed
      ? {
          moreText: { ...this.TOOLBAR_BUTTONS.moreText, buttonsVisible: 2 },
          moreParagraph: { ...this.TOOLBAR_BUTTONS.moreParagraph, buttonsVisible: 0 },
          moreRich: { ...this.TOOLBAR_BUTTONS.moreRich, buttonsVisible: 0 },
          moreMisc: { ...this.TOOLBAR_BUTTONS.moreMisc },
        }
      : this.TOOLBAR_BUTTONS;

    const height = condensed ? widgetHeight - 60 : widgetHeight - 261;

    return {
      toolbarInline: condensed,
      toolbarButtons,
      height,
      heightMax: height,
    };
  }

  public options: object = {
    key: environment.froalaKey,
    charCounterCount: false,
    wordCounterCount: true,
    placeholderText: translate('widgets.widget-notes-editor.add-your-note-here'),
    toolbarButtons: WidgetNotesEditorComponent.TOOLBAR_BUTTONS,
    tabSpaces: 4,
    imageInsertButtons: ['imageByURL'],
    toolbarVisibleWithoutSelection: true,
    imageUpload: false,
    imageUploadRemoteUrls: false,
    imagePaste: false,
    autofocus: true,
    events: {
      initialized: (e: any) => {
        this.editor = e.getEditor();
        if (this.mode === 'markdown') {
          this.editor.markdown.toggle();
        }
      },
      blur: () => this.editFinished.emit(true),
    },
    attribution: false,
  };
  editor;

  ngOnInit() {
    Object.assign(
      this.options,
      WidgetNotesEditorComponent.getEditorLayoutOptions(this.condensed, this.widgetHeight)
    );

    if (this.mode === 'markdown') {
      this.options['toolbarButtons'] = [];
      this.options['imageInsertButtons'] = [];
      this.options['events']['toolbar.show'] = function () {
        return false;
      };
    }
  }

  onContentChange(value) {
    this.contentChange.emit(value);
  }
}
